import React from "react";
import { useSettings } from "../lib/settings";

export function Logo({ size = "md", inverted = false }) {
  const settings = useSettings();
  const sizes = { sm: "text-lg", md: "text-xl", lg: "text-2xl", xl: "text-3xl" };
  const name = settings.institute_name || "YoungMinds";
  const color = settings.primary_color || "#2563EB";
  return (
    <div className="flex items-center gap-2" data-testid="ym-logo">
      {settings.logo_url ? (
        <img src={settings.logo_url} alt="logo" className="rounded-xl object-cover shadow-md"
          style={{ width: 36, height: 36 }} />
      ) : (
        <div
          className={`grid place-items-center rounded-xl shadow-md ${inverted ? "bg-white" : "text-white"}`}
          style={{ width: 36, height: 36, background: inverted ? "#fff" : color, color: inverted ? color : "#fff" }}
        >
          <span className="font-heading font-black text-base">{name[0]?.toUpperCase()}</span>
        </div>
      )}
      <div className="leading-tight">
        <div
          className={`font-heading font-black tracking-tighter ${sizes[size]} ${inverted ? "text-white" : "text-slate-900"}`}
        >
          {name}<span style={{ color }}>.</span>
        </div>
      </div>
    </div>
  );
}

export const TAGLINE_FALLBACK = "We rise by Lifting Others";
export function useTagline() {
  const s = useSettings();
  return s.tagline || TAGLINE_FALLBACK;
}

// Backwards-compat constant export
export const TAGLINE = TAGLINE_FALLBACK;
